import { useLocation } from "@entry/navigation";

import { Routes } from "@ctypes";
import { useWindowDimensions } from "@hooks";
import { calculateProgress } from "@utils";
import { ONBOARDING_ROUTES } from "./routes";
import { useStyles } from "./styles";

export const ProgressBar = () => {
  const styles = useStyles();

  const { width } = useWindowDimensions();

  const location = useLocation();

  const route = location.pathname as Routes;

  const index = ONBOARDING_ROUTES.indexOf(route);

  const shouldDisplayProgress = ONBOARDING_ROUTES.includes(route);

  if (!shouldDisplayProgress) return null;

  const progress = calculateProgress(index, ONBOARDING_ROUTES.length);

  return (
    <div style={styles.background}>
      <div style={{ ...styles.bar, width: width * progress }} />
    </div>
  );
};
